import moment from 'moment/moment';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ IsFeatured, Title, ShortDescription, ImageUrl, CreatedAt, Category, Id }) => {
  const cutNumber = 110;
  const truncateShortDescription = useMemo(() => {
    if (ShortDescription.length > cutNumber) {
      return ShortDescription.slice(0, cutNumber - 1) + '...';
    }
    return ShortDescription;
  }, [ShortDescription]);

  return (
    <div className="rounded-lg relative grid grid-rows-[max-content] text-left">
      <div style={{ backgroundImage: `url(${ImageUrl})` }} className="h-[200px] bg-cover bg-center rounded-tl-xl rounded-tr-xl relative" />
      {IsFeatured && <div className="absolute top-2 left-5 bg-blue-700 text-white-50 px-3 py-1 rounded-lg shadow uppercase">Featured</div>}
      <div className=" pt-2 pr-5 grid content-between justify-start">
        <div>
          <p className="italic text-sm mb-2 text-grey-800 font-light">{moment(CreatedAt).format('MMMM DD, YYYY')}</p>
          <Link to={Id} className="grid">
            <h2 className="text-xl font-bold text-blue-800 hover:underline">{Title}</h2>
          </Link>
          <p className="text-grey-700">{truncateShortDescription}</p>

          <div className="mb-5 mt-2">
            <span className="border px-2 rounded-xl border-blue-700 text-light-grey-700 text-sm">{Category}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
